<template>
  <router-link :to="'/campaigns/'+campaign.id" class="card--search">
    <div v-if="campaign.acf.merchant_logo" class="card--search__image">
      <img :src="campaign.acf.merchant_logo">
    </div>
    <div class="card--search__content">
      <span class="card--search__title">
        {{ campaign.title }}
      </span>
      <span class="card--search__rate">
         Up to {{ campaign.acf.commission_rate }}
      </span>
    </div>
  </router-link>
</template>

<script>

export default {
  name: 'Search Card',
  components: {
  },
  props: {
    campaign: {
      type : Object
    }
  }
}
</script>

<style lang="scss" scoped>

@use "@/scss/mixins.scss";
@use "@/scss/variables.scss";
@import "../scss/styles.scss";

.card--search{
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  align-items: center;
  width: 100%;
  transition: 0.2s;
  padding-top: 1.3rem;
  padding-bottom: 1.2rem;
  padding-left:1.5rem;
  padding-right: 1.5rem;
  border-bottom: 1px solid rgba($light_grey, 0.6);
  box-sizing: border-box;
  &:hover{
    cursor: pointer;
    background-color: rgba(0,0,0,0.04);
    transition: 0.2s;
  }
  &__image{
    width: 6rem;
    box-sizing: border-box;
    display: flex;
    align-content: center;
    align-items: center;
    height: 100%;
  }
  &__content{
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    align-items: flex-start;
    overflow: hidden;
    padding-left: 2rem;
    span{
      width: 100%;
    }
  }
  &__title {
    font-size: 1.4rem;
    line-height: 1.9rem;
    font-weight: 600;
    color:$darkblue;
  }
  &__rate {
    margin-top: 0.2rem;
    font-size: 1.4rem;
    line-height: 1.9rem;
    color:$darkblue;
    font-weight: 600;
  }
  &:first-of-type{
    padding-top: 1.6rem;
  }
  &:last-of-type{
    border: 0;
    margin-bottom: 0;
    padding-bottom: 1.6rem;
  }
}


</style>

